const { mapStateToProps } = require('@reverbdotcom/discovery-ui');

const MediaMailInput = require('../media_mail_input');
const {
  store: ShippingLabelStore,
  actions: ShippingLabelActions,
} = require('../shipping_label_form_module');

function mapper() {
  const { shipment } = ShippingLabelStore.getState();
  let mediaMailQualified = false;
  let eligibleForMediaMail = true;

  if (shipment) {
    eligibleForMediaMail = shipment.mediaMailEligible;
    ({ mediaMailQualified } = shipment);
  }

  return {
    mediaMailQualified,
    eligibleForMediaMail,
    toggleMediaMailQualified: ShippingLabelActions.toggleMediaMailQualified,
  };
}

module.exports = mapStateToProps({
  mapper, stores: [ShippingLabelStore],
})(MediaMailInput, 'MediaMailInput');



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/containers/media_mail_input_container.jsx